import { apiClient, getApiBaseUrl } from './client.js';

/**
 * Nghe trạng thái đơn theo thời gian thực (SSE GET /payments/orders/:id/stream). Dùng fetch thay vì EventSource
 * để gửi kèm token đăng nhập ở header. Kết thúc khi backend đóng luồng hoặc `signal` bị hủy.
 * @param {string} orderId
 * @param {(status: string) => void} onStatus
 * @param {AbortSignal} signal
 */
async function streamOrderStatus(orderId, onStatus, signal) {
  const token = localStorage.getItem('lms_token');
  const res = await fetch(`${getApiBaseUrl()}/payments/orders/${orderId}/stream`, {
    headers: { Accept: 'text/event-stream', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    cache: 'no-store',
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`Không mở được luồng trạng thái (HTTP ${res.status})`);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buffer += decoder.decode(value, { stream: true });
    let end;
    while ((end = buffer.indexOf('\n\n')) >= 0) {
      const dataLine = buffer
        .slice(0, end)
        .split('\n')
        .find((line) => line.startsWith('data:'));
      buffer = buffer.slice(end + 2);
      if (!dataLine) continue; // dòng giữ kết nối
      try {
        onStatus(JSON.parse(dataLine.slice(5)).status);
      } catch {
        // sự kiện hỏng: bỏ qua
      }
    }
  }
}

export const paymentApi = {
  createOrder: (planId) => apiClient.post('/payments/orders', { planId }),
  getOrderStatus: (orderId) => apiClient.get(`/payments/orders/${orderId}`),
  streamOrderStatus,

  // Admin
  getAllOrders: (params) => apiClient.get('/payments/orders', { params }),
};
